import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import Results from "@/pages/Results";
import BreedBrowser from "@/pages/BreedBrowser";
import BreedProfile from "@/pages/BreedProfile";
import Adoption from "@/pages/Adoption";
import Breeders from "@/pages/Breeders";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import Saved from "@/pages/Saved";
import Upgrade from "@/pages/Upgrade";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refunds from "@/pages/Refunds";
import Compare from "@/pages/Compare";
import FurMeter from "@/pages/FurMeter";
import ChaosMeter from "@/pages/ChaosMeter";
import Play from "@/pages/Play";
import SpeedDating from "@/pages/SpeedDating";
import AdminLinks from "@/pages/AdminLinks";
import ChatWidget from "@/components/ChatWidget";
import { EntitlementProvider } from "@/lib/entitlement";
import { FavoritesProvider } from "@/lib/favorites";
import { trackPageView } from "@/lib/tiktok";
import { trackGAPageView } from "@/lib/ga";

function AppRouter() {
  const location = useLocation();
  // Fire a TikTok + GA4 PageView on every SPA route change (safe no-op if not configured).
  useEffect(() => { trackPageView(); trackGAPageView(location.pathname); }, [location.pathname]);
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/results" element={<Results />} />
        <Route path="/breeds" element={<BreedBrowser />} />
        <Route path="/breeds/:id" element={<BreedProfile />} />
        <Route path="/adoption" element={<Adoption />} />
        <Route path="/breeders" element={<Breeders />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/:slug" element={<GuideDetail />} />
        <Route path="/saved" element={<Saved />} />
        <Route path="/upgrade" element={<Upgrade />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refunds" element={<Refunds />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/fur-meter" element={<FurMeter />} />
        <Route path="/chaos-meter" element={<ChaosMeter />} />
        <Route path="/play" element={<Play />} />
        <Route path="/speed-dating" element={<SpeedDating />} />
        <Route path="/admin/links" element={<AdminLinks />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <EntitlementProvider>
          <FavoritesProvider>
            <AppRouter />
            <ChatWidget />
            <Toaster position="top-center" richColors />
          </FavoritesProvider>
        </EntitlementProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
